export const environment = {
  production: false,
  api_url: "https://steer-api-dev.tenxengage-nprd.com/api",
  maintenanceUrl: "https://steer-mtnc-api-dev.tenxengage-nprd.com/api",
  redeemptionUrl: "http://steer-redem-api-dev.tenxengage-nprd.com/api",
  oidc: {
    domain:
      "https://keycloak.tenxengage-nprd.com/realms/sellerrewards/protocol",
    clientId: "sellerrewards-dev-frontend",
    redirectUri: "https://steer-dev.tenxengage-nprd.com/callback",
    scopes: ["openid", "profile", "email", "offline_access"],
    pkce: true,
    responseType: "code",
    grant_type: "authorization_code",
    endPoints: {
      issuer: "",
      authorize: "/openid-connect/auth",
      token: "/openid-connect/token",
      userInfo: "/openid-connect/userinfo",
      logout: "/openid-connect/logout",
    },
  },
  userNameKeyFromOIDC: "nickname",
};
